// Use this alias to overcome TypeScript limitation when necessary.
const keys = Object.keys as <T>(o: T) => (keyof T)[];
export default keys;
